<div class="outer-container">
  <span class="currentStatusTitile">Alert</span>
  <div class="console-container">
    <div class="input-wrapper">
      <div class="row">
        <p>{{ getErrorMessage() }}</p>
      </div>
    </div>
    <div class="bottom-line"></div>
    <div class="text-center">
      <button class="btn-button">
        <span class="btn-ok-button" (click)="Logout()">OK</span>
      </button>
    </div>
  </div>
</div>
